module.exports = {
    "id": "trunk",
    "title": "trunk",
    "image": "provision/parts/trunk/trunk.png",
    "info": [
      {
        "text": "Add a tree trunk to your project",
        "image": "provision/parts/trunk/trunk.png"
      }
    ],
    "exposedVariables": [],
    "codeImage": "provision/parts/trunk/trunk.png"
  } ;